<!-- 加入我们 -->
<template>

    <div class="aboubox">
        <div @click="istab = false" v-show="istab" class="tabbox nobg">
            <div class="hadtabs ">
                <ul>
                    <li>
                        <router-link to="/h5home">官网首页</router-link>
                    </li>
                    <li>
                        <router-link to="/h5recharge">账户充值</router-link>
                    </li>
                    <li>
                        <router-link to="/h5enlist">主播招募</router-link>
                    </li>
                    <li class="active">
                        <router-link to="/h5aboutus">关于我们</router-link>
                    </li>
                    <li>
                        <router-link to="/h5contactus">联系我们</router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="heradbox">
            关于我们 <i @click="istab = true" class="tabicon"></i>
        </div>
        <div class="content">
            <i class="logoicon"></i>
            <p>&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;暖暖星球是广州赛驷网络科技有限公司旗下的一款直播软件，是一个综合性的全民手机直播交友App。
                视频K歌，交友聊天，才艺表演，高颜值的都在暖暖星球，这里拒绝色情和低俗。
                在暖暖星球，你可以通过直播、视频、文字、语音、图片来展示自己， 基于地理位置发现附近的人，同城交友，建立真实、有效、健康的社交关系。
                3年老平台值得信赖，快进入直播间与Ta面对面互动吧，你的Ta从未如此真实，如此靠近你。</p>
        </div>
        <Footer></Footer>
    </div>
</template>
<script>
import Footer from "../../components/h5footer"
export default {
    components: {
        Footer
    },
    data() {
        return {
            istab: false,
        }
    },
    created() {

    },
    methods: {

    },
}
</script>
<style lang="less" scoped>
.aboubox {
    width: 100%;
    height: 100%;
    background: #F7F7F7;
}

.heradbox {
    width: 100%;
    height: 1.33rem;
    background: #fff;
    position: relative;
    margin-bottom: .22rem;
    font-size: 0.48rem;
    color: #333333;
    line-height: 1.33rem;
    text-align: center;
    font-weight: 500;

    .tabicon {
        background: url('https://resource.imbeiyu.com/gw/assets/images/h5/icon-more-black.png');
        background-size: 100% 100%;
        position: absolute;
        right: .34rem;
        top: .3rem;
        width: .7rem;
        height: .75rem;
    }
}

.content {
    padding: .8rem .6rem;

    .logoicon {
        display: block;
        margin: 0 auto;
        background: url('https://resource.imbeiyu.com/nnxqGw/img/pic-logo-r.png');
        background-size: 100% 100%;
        width: 4rem;
        height: 4.1rem;

    }

    p {
        margin-top: .45rem;
        font-size: 0.37rem;
        width: 100%;
        text-align: left;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 0.6rem;
        color: rgba(51, 51, 51, 1);
    }

}
</style>


// WEBPACK FOOTER //
// src/page/h5page/h5aboutus.vue